var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "page"
  }, [_c('h1', {
    staticClass: "form-title"
  }, [_vm._v("請詳實填寫郵寄資訊")]), _c('DynamicForm', {
    ref: "dynamicForm",
    staticClass: "my-4 mx-2",
    attrs: {
      "input-subjects": _vm.form
    },
    model: {
      value: _vm.inputForm,
      callback: function callback($$v) {
        _vm.inputForm = $$v;
      },
      expression: "inputForm"
    }
  }), _vm._m(0), _c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'LiffRewardsCardReceiver'
        });
      }
    }
  }, [_vm._v(" 送出 ")])], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "reward-notice s-p-3"
  }, [_c('ol', [_c('li', [_vm._v("請勿必詳實填寫贈品郵寄資訊。")]), _c('li', [_vm._v(" 如因填寫資訊有誤致使贈獎程序無法完成，衍生之成本與寄送責任應由贈獎者自行負擔。 ")])])]);
}]

export { render, staticRenderFns }